import BrSelect from '@govbr/react-components/lib/BrSelect';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from 'react-router-dom';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import TimeLine from "./Timeline/Timeline";

import styles from './PainelBeneficios.module.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { alterarBeneficioSelecionado, alterarDataFinal, alterarDataInicial, obterExtratoBeneficio, obterFamilia, selectBeneficioSelecionado,
  selectExtratoBeneficios, selectFamilia, selectState } from './BeneficiosSlice';
import auth from '../../auth/Auth';
import { tipoBeneficios, mensagensAjudaTipoBeneficio } from '../../common/enum';
import { currencyFormat, obterMesAnoExtenso } from '../../common/formatadores';
import moment from 'moment';
import * as mensagem from '../../common/Mensagens'
import { Dialog, DialogContent } from '@material-ui/core';
import BrButton from '@govbr/react-components/lib/BrButton';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import Message from '../../components/Message/Message';
import { MSG_NAO_FORAM_ENCONTRADOS_BENEFICIOS } from '../../common/Mensagens';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';

const ExtratoBeneficios: React.FC = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const beneficioSelecionado = useAppSelector(selectBeneficioSelecionado);

  const [alerta, setAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState('');

  const familia = useAppSelector(selectFamilia);
  const extrato = useAppSelector(selectExtratoBeneficios);

  const state = useAppSelector(selectState);

  const perfil = useAppSelector(selectPerfilCompleto);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  useEffect(() => {
    if (!familia) {
      dispatch(obterFamilia(auth.getUser()));
    }
    if (!extrato) {
      const dados = {
        nuFamiliar : perfil?.numeroFamiliar,
        tipoPerfil: perfil?.tipoPerfil,
        cpf: perfil?.cpf,
        tipoConsulta: beneficioSelecionado,
        dataInicial: state.dataInicial,
        dataFinal: state.dataFinal
      }
      dispatch(obterExtratoBeneficio(dados));
    }
  }, [dispatch, familia, beneficioSelecionado, state.dataInicial, state.dataFinal, extrato, perfil]);

  const handleTipoBeneficio = async(tipo) => {
    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta: tipo,
      dataInicial: state.dataInicial,
      dataFinal: state.dataFinal
    }

    await dispatch(alterarBeneficioSelecionado(tipo))
    await consultarExtratoBeneficio(dados);
  };

  const consultarExtratoBeneficio = async(dados: any) => {
    if (validarCamposObrigatorios(dados)) {
      await dispatch(alterarDataInicial(dados.dataInicial));
      await dispatch(alterarDataFinal(dados.dataFinal));
      await dispatch(obterExtratoBeneficio(dados));
    }
  }

  const validarCamposObrigatorios = (dados: any) => {
    if (!dados.dataInicial || !dados.dataFinal) {
      setMensagemAlerta('Período deve ser preenchido.');
      setAlerta(true);
      return false;
    }

    let periodoInicial = moment(dados.dataInicial, "MM/YYYY");
    let periodoFinal = moment(dados.dataFinal, "MM/YYYY");

    if (moment(periodoInicial, "MM/YYYY") > moment(periodoFinal, "MM/YYYY")) {
      setMensagemAlerta('Período inicial deve ser menor ou igual ao período final.');
      setAlerta(true);
      return false;
    }

    return true;
  }

  const voltarParaPainel = () => {
    history.goBack();
  };

  const obterTiposDeBeneficio = () => {
    const value = tipoBeneficios.find(
      (tipoDocumento) => tipoDocumento.value === beneficioSelecionado
    );
    return value ? value : '';
  };

  const obterTipoDeBeneficioPorCodigo = (codigo: any) => {
      return tipoBeneficios.find((b) =>
        b.value === codigo
          ? {
            label: b.label,
            value: b.value,
          }
          : null
      );
  };

  const mensagemBeneficiosNaoEncontrados = () => {
    return (
      <Message id="mensagem" type="warning" title={MSG_NAO_FORAM_ENCONTRADOS_BENEFICIOS} className={styles.message} />
    )
  }

  const obterMensagemAjuda = (codigo: string) => {
    let mensagemAjuda
    mensagemAjuda = mensagensAjudaTipoBeneficio.find(
      mensagem => mensagem.value === codigo
    );

    return mensagemAjuda?.label ? mensagemAjuda?.label : '';
  };

  const renderizarTimeline = () => {
    if (extrato) {
      let extratos = extrato.map((e, i) => {
        const tipoBeneficio = obterTipoDeBeneficioPorCodigo(e.tipoExtrato.codigo);
        const competencia = obterMesAnoExtenso(e.numeroCompetencia);

        if (tipoBeneficio?.value === 1) {
          return {
            codigo: e.tipoExtrato.codigo,
            tipoBeneficio: tipoBeneficio,
            mes: competencia?.mesExtenso + " " +  competencia?.anoCompetencia,
            categoriaPrograma: tipoBeneficio?.label,
            programa: e.nomeBeneficio,
            valor: currencyFormat(e.valorBeneficio),
            descricaoAjuda: obterMensagemAjuda(e.siglaTipoBeneficio),
            situacao: e.situacaoBeneficio,
            sigla: e.siglaTipoBeneficio,

          }
        }

        if (tipoBeneficio?.value === 2) {
          return {
            codigo: e.tipoExtrato.codigo,
            tipoBeneficio: tipoBeneficio,
            nomeBeneficiario: e.nomeBeneficiario,
            valor: currencyFormat(e.valorBeneficio),
            mes: competencia?.mesExtenso + " " +  competencia?.anoCompetencia,
            categoriaPrograma: tipoBeneficio?.label,
            programa: e.nomeBeneficio,
            detalhePrograma: "Espécie: ",
            descricaoDetalhePrograma: e.nomeEspecie,
            descricaoAjuda: mensagem.MSG_AJUDA_BPC
          }
        }

        if (tipoBeneficio?.value === 3) {
          return {
            codigo: e.tipoExtrato.codigo,
            tipoBeneficio: tipoBeneficio,
            nomeBeneficiario: e.nomeBeneficiario,
            valor: currencyFormat(e.valorBeneficio),
            mes: competencia?.mesExtenso + " " +  competencia?.anoCompetencia,
            categoriaPrograma: tipoBeneficio?.label,
            descricaoAjuda: obterMensagemAjuda(e.siglaTipoBeneficio),
          }
        }

        if (tipoBeneficio?.value === 4) {
          return {
            codigo: e.tipoExtrato.codigo,
            tipoBeneficio: tipoBeneficio,
            nomeBeneficiario: e.nomeBeneficiario,
            valor: currencyFormat(e.valorDesconto),
            mes: competencia?.mesExtenso + " " +  competencia?.anoCompetencia,
            categoriaPrograma: tipoBeneficio?.label,
            descricaoAjuda: obterMensagemAjuda(e.siglaTipoBeneficio),
            distribuidora: e.nomeDistribuidora,
            unidadeConsumidora: e.numeroUnidadeConsumidora
          }
        }

        return null;
      });

      if (extratos && extratos.length > 0) {
        return (
          <TimeLine itens={extratos} />
        )
      } else {
        mensagemBeneficiosNaoEncontrados();
      }
    }
    return (
      mensagemBeneficiosNaoEncontrados()
    )
  }

  const handleDataInicial = async(dataInicio: Date) => {
    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta: beneficioSelecionado,
      dataInicial: dataInicio,
      dataFinal: state.dataFinal
    }
    await consultarExtratoBeneficio(dados);
  }

  const handleDataFinal = async(dataFim: Date) => {
    const dados = {
      nuFamiliar : perfil?.numeroFamiliar,
      tipoPerfil: perfil?.tipoPerfil,
      cpf: perfil?.cpf,
      tipoConsulta: beneficioSelecionado,
      dataInicial: state.dataInicial,
      dataFinal: dataFim
    }
    await consultarExtratoBeneficio(dados);
  }

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  return (
    <MainContainer
      userNav={isLogado()}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar={"Meus Benefícios"}
      barraAuxiliar={true}
      navFixed
      stoppedTitle={true}
      navSeparator={false}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={logout}
      navGoBack={voltarParaPainel}>
      <div className={styles.container} id="topo">
        <Dialog
          open={alerta}
          onClose={() => setAlerta(!alerta)}
        >
          <div className={styles.container}>
            <DialogContent className={styles.modalContainer}>
              {mensagemAlerta}
            </DialogContent>
            <div className={styles.modalFooter}>
              <BrButton className={styles.button} onClick={() => setAlerta(false)}>
                OK
              </BrButton>
            </div>
          </div>
        </Dialog>

        <Card semEstilo>
          <>
            <div className={styles.topoPeriodoBeneficio}>
              <div className={styles.textoTopo}>É possível filtrar por período e benefício recebido.</div>
              <div className={styles.blocoPeriodoBeneficio}>
                <div className={styles.periodo}>Período:</div>
                <div>
                  <DatePicker
                    selected={state.dataInicial}
                    onChange={(date) => handleDataInicial(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    locale={ptBR}
                    wrapperClassName={styles.datepicker}
                  />
                </div>
                <span>até</span>
                <div>
                  <DatePicker
                    selected={state.dataFinal}
                    onChange={(date) => handleDataFinal(date)}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                    locale={ptBR}
                    wrapperClassName={styles.datepicker}
                  />
                </div>
              </div>
              <div className={styles.blocoPeriodoBeneficio}>
                <div className={styles.beneficio}>
                  Benefício:
                </div>
                <div className={styles.brSelect}>
                <BrSelect
                  id="beneficios"
                  placeholder = "Todos (linha do tempo)"
                  value={obterTiposDeBeneficio()}
                  items={tipoBeneficios.map((b) => ({ label: b.label, value: b.value }))}
                  onChange={(event) => handleTipoBeneficio(event)}
                />
                </div>
              </div>
              <hr/>

              {renderizarTimeline()}
            </div>
          </>
        </Card>
      </div>
    </MainContainer>
  )
}

export default ExtratoBeneficios;
